<div class="card asignar-responsable-ia-modal" [class]="vista.claseModal">
  <div class="card-header card-header-primary">
    <div class="row">
      <div class="col-sm-12 col-md-11">
        <h4 class="card-title"><b>{{ vista.titulo }}</b></h4>
        <p class="card-category">
          Folio <strong>#{{ data?.incidencia?.idIncidenciaIa }}</strong> - Pasar incidencia a proceso
        </p>
      </div>
      <div class="col-sm-12 col-md-1 text-right">
        <button type="button" mat-icon-button aria-label="Cerrar" (click)="cerrar()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="wraper">
      <div class="container">
        <div class="alert alert-danger asignar-responsable-ia-modal__alert" *ngIf="error">
          <i class="material-icons">error_outline</i>
          <span>{{ error }}</span>
        </div>

        <div class="text-center text-muted my-4" *ngIf="cargando">
          <i class="material-icons">hourglass_top</i>
          <strong>Cargando responsables...</strong>
        </div>

        <ng-container *ngIf="!cargando">
          <div class="asignar-responsable-ia-modal__summary">
            <span>Incidencia</span>
            <strong>{{ resumenIncidencia }}</strong>
            <p>{{ data?.incidencia?.descripcionEvento || "Sin descripcion" }}</p>
          </div>

          <div class="asignar-responsable-ia-modal__self" *ngIf="puedeAsignarme()">
            <button type="button" mat-button class="btn btn-default" (click)="asignarme()">
              Tomar yo <i class="material-icons">person_pin</i>
            </button>
          </div>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ vista.etiquetaResponsable }}</mat-label>
            <mat-select
              #responsableSelect
              [(ngModel)]="idEmpleadoSeleccionado"
              [disabled]="guardando || !responsables.length"
              [panelClass]="vista.clasePanel"
              [attr.panelClass]="vista.clasePanel"
              (selectionChange)="onResponsableSeleccionado()">
              <mat-option *ngFor="let responsable of responsables" [value]="responsable.idEmpleado">
                {{ nombreResponsable(responsable) }}<ng-container *ngIf="perfilResponsable(responsable)"> - {{ perfilResponsable(responsable) }}</ng-container>
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100 asignar-responsable-ia-modal__comment">
            <mat-label>{{ vista.etiquetaMotivo }}</mat-label>
            <textarea
              [attr.aria-label]="vista.etiquetaMotivo"
              matInput
              rows="4"
              maxlength="350"
              [(ngModel)]="comentarioReasignacion"
              name="comentarioReasignacion"
              [disabled]="guardando"
              required
              [placeholder]="vista.placeholderMotivo"
            ></textarea>
          </mat-form-field>

          <div class="asignar-responsable-ia-modal__empty" *ngIf="!responsables.length">
            <i class="material-icons">group_off</i>
            <span>{{ vista.sinResponsables }}</span>
          </div>
        </ng-container>

        <div mat-dialog-actions class="justify-content-end asignar-responsable-ia-modal__actions">
          <button type="button" mat-button class="btn btn-default" (click)="cerrar()" [disabled]="guardando">
            Cancelar
          </button>
          <button
            type="button"
            mat-button
            class="btn btn-success"
            (click)="asignar()"
            [disabled]="guardando || cargando || !idEmpleadoSeleccionado || !comentarioReasignacion.trim()">
            {{ guardando ? "Asignando..." : "Asignar y pasar a proceso" }}
            <i class="material-icons">assignment_ind</i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
